import "./intro.css";

import React from "react";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import img from '../../assets/profile.jpg';

// import ME from '../../assets/Rasif Tagizade image.jpg';


const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={img} alt="suresh reddy" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1+ year</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed Projects</small>
            </article>
          </div>
          <p>
          Full Stack Developer with over a  1+  year of experience in building and maintaining dynamic web applications, specializing in both frontend and backend technologies. Skilled in designing and implementing responsive user interfaces using React.js, translating designs and wireframes into clean, high-quality code. Proficient in JavaScript, Node.js, MongoDB, HTML, CSS, and MySQL, with a strong understanding of full-stack development workflows. Experienced in monitoring and optimizing both frontend and backend performance, with expertise in troubleshooting and debugging to enhance overall application efficiency.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
